// Full-text search across all messages in channels the current user belongs
// to. Wraps the chat_search_messages SQL function added in 0014_chat_v2.
import { getSDK } from '../sdk.js'

export const searchMessages = async function (query) {
  const root = this.state.root
  const q = (query || '').trim()
  if (!q) {
    root.update({ searchResults: [], searchQuery: '' })
    return
  }
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.search rpc
    const result = await getSDK().execute('workspaceProject.chat.search', 'rpc', {
      q,
      callerEmail: root.currentUserEmail
    })
    const data = result?.data ?? result ?? []
    root.update({ searchQuery: q, searchResults: Array.isArray(data) ? data : [] })
  } catch (e) {
    console.error('[searchMessages]', e?.message || e)
    root.update({ searchQuery: q, searchResults: [] })
  }
}

export const openSearch = function () {
  this.state.root.update({ searchOpen: true, searchQuery: '', searchResults: [] })
}

export const closeSearch = function () {
  this.state.root.update({ searchOpen: false, searchQuery: '', searchResults: [] })
}
